/**
 * The typed API surface, grouped the way the backend's routers are grouped
 * (architecture §6): `api.auth.*`, `api.onboarding.*`, `api.matches.*`.
 */

import * as account from './account'
import * as apply from './apply'
import * as auth from './auth'
import * as matches from './matches'
import * as onboarding from './onboarding'

export const api = { auth, onboarding, matches, account, apply }

export { ApiError } from './client'
export type { SessionUser, SignInResponse } from './auth'
export type {
  CvUploadResponse,
  FinalizeOnboardingResponse,
  SavedConstraints,
  SavedCv,
  SavedMatchSetup,
} from './onboarding'
export type { ColdStartResponse } from './matches'
export type { SaveArtifactRequest, TailorCvResponse, WriteLetterResponse } from './apply'
